import React, { useState } from 'react'
import { useLocation } from 'react-router'
import { bool } from 'prop-types'

import useDidMount from '@divvy-web/hooks.usedidmount'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import AppHeader from '@divvy-web/skylab.appheader'
import BasicButton from '@divvy-web/skylab.basicbutton'
import Modal from '@divvy-web/skylab.modal'

import { useDebounce } from '@sputnik/hooks/useDebounce'

import styles from './styles.module.scss'

const BdcLanding = () => {
  const { search } = useLocation()
  const [getClassName, makeTestId] = useNameFormatter('BdcLanding')
  const params = new URLSearchParams(search)
  const email = params.get('email') || (
    <FormattedMessage
      defaultMessage='your email'
      id='sputnik.BdcLanding__4sARcm'
    />
  )
  const [isModalShowing, setModalIsShowing] = useState(false)
  const isModalShowingDebounced = useDebounce(isModalShowing, 1000)

  useDidMount(() => {
    setTimeout(() => setModalIsShowing(true), 60_000)
  })

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('page')}
    >
      <a href='/'>
        <div
          className={styles[getClassName('logo')]}
          data-testid={makeTestId('logo')}
        />
      </a>
      <div className={styles[getClassName('content')]}>
        <section
          className={styles[getClassName('content-text-section')]}
          data-testid={makeTestId('message')}
        >
          <AppHeader>
            <h1>
              <FormattedMessage
                defaultMessage='Save time on your credit application'
                id='sputnik.BdcLanding__HGZtrc'
              />
            </h1>
          </AppHeader>
          <div className={styles[getClassName('content-description')]}>
            <h2 className={styles[getClassName('content-next-steps')]}>
              <FormattedMessage
                defaultMessage='Next steps'
                id='sputnik.BdcLanding__uhBRmg'
              />
            </h2>
            <ol>
              <li>
                <FormattedMessage
                  defaultMessage='Check {email} for a link to start your credit application.'
                  id='sputnik.BdcLanding__4oRnLY'
                  values={{ email }}
                />
              </li>
              <li>
                <FormattedMessage
                  defaultMessage='Review the information that has been pre-filled from your BILL account to make sure everything looks accurate.'
                  id='sputnik.BdcLanding__EPfSP3'
                />
              </li>
              <li>
                <FormattedMessage
                  defaultMessage='Once everything looks good, submit your application.'
                  id='sputnik.BdcLanding__v1fbA1'
                />
              </li>
            </ol>
          </div>
        </section>
      </div>
      <CheckEmailModal isShowing={isModalShowingDebounced} />
    </div>
  )
}

const CheckEmailModal = ({ isShowing }) => {
  const [isDismissed, setIsDismissed] = useState(false)

  return (
    <Modal
      actions={[
        <BasicButton
          key='gotit'
          onClick={() => setIsDismissed(true)}
        >
          <FormattedMessage
            defaultMessage='Got It'
            id='sputnik.BdcLanding__g+ZfxV'
          />
        </BasicButton>,
      ]}
      isShowing={isShowing && !isDismissed}
      title={
        <FormattedMessage
          defaultMessage="Don't forget to check your inbox!"
          id='sputnik.BdcLanding__dfgODe'
        />
      }
    >
      <p>
        <FormattedMessage
          defaultMessage='We sent you a personalized email to help you start your credit application. Please keep an eye out for the invitation!'
          id='sputnik.BdcLanding__AAAtSl'
        />
      </p>
    </Modal>
  )
}

CheckEmailModal.propTypes = {
  isShowing: bool,
}

export default BdcLanding
